var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcArrowDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "7px",
    viewBox: "0 0 12 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 11.0724 0 11.0724 6.1999 0 6.1999"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-copy-2",
    transform: "translate(-1328.000000, -101.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(835.000000, 93.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    transform: "translate(455.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1-Clipped",
    transform: "translate(44.000000, 11.500000) rotate(0.000000) translate(-44.000000, -11.500000) translate(38.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0724,-0.30009 C11.0724,-0.12009 11.0024,0.05991 10.8724,0.19991 L6.5324,4.54991 L6.1024,4.96991 C5.9524,5.10991 5.7524,5.19991 5.5324,5.19991 C5.3424,5.19991 5.1624,5.12991 5.0224,5.01991 L0.2024,0.19991 C-0.0676,-0.08009 -0.0676,-0.52009 0.2024,-0.79009 C0.4724,-1.07009 0.9224,-1.07009 1.1924,-0.79009 L5.5424,3.55991 L9.8824,-0.79009 C10.1524,-1.07009 10.5924,-1.07009 10.8724,-0.79009 C11.0024,-0.66009 11.0724,-0.48009 11.0724,-0.30009",
    id: "Fill-1",
    fill: "#333939",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowDown);
export default __webpack_public_path__ + "static/media/ic_arrow_down.c3f6f230.svg";
export { ForwardRef as ReactComponent };